var $faqBlocks,
  kbSearchPageLink;

$(document).ready(function($) {

  $faqBlocks = $(".b-support");

  if ($faqBlocks.length) {
    $faqBlocks.each(function () {
      var $thisBlock = $(this);
      kbSearchPageLink = $thisBlock.data('mpkbpath');

      var $searchInput = $thisBlock.find('.c-search-block__input');
      var $searchIcon = $thisBlock.find('.c-search-block__icon');

      $searchIcon.click(function(){
        navigateToKbSearch($searchInput.val());
      });

      $searchInput.on('keyup', function(e) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode === '13' || keycode === 13 || e.key === 'Enter') {
          navigateToKbSearch($searchInput.val());
        }
      });

    });
  }


});

function navigateToKbSearch(searchQuery) {
  if(searchQuery.length) {
    window.location.href = kbSearchPageLink + '#s=' + encodeURI(searchQuery);
  }
}
